/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSurveyUnitsOfMeasures } from 'app/entities/survey-units-of-measure/survey-units-of-measure.reducer';
import { getEntities as getSurveyQuestionOptions } from 'app/entities/survey-question-option/survey-question-option.reducer';
import { createEntity, getEntity, reset, updateEntity } from './survey-answer.reducer';

export const SurveyAnswerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const surveyUnitsOfMeasures = useAppSelector(state => state.surveyUnitsOfMeasure.entities);
  const surveyQuestionOptions = useAppSelector(state => state.surveyQuestionOption.entities);
  const surveyAnswerEntity = useAppSelector(state => state.surveyAnswer.entity);
  const loading = useAppSelector(state => state.surveyAnswer.loading);
  const updating = useAppSelector(state => state.surveyAnswer.updating);
  const updateSuccess = useAppSelector(state => state.surveyAnswer.updateSuccess);

  const handleClose = () => {
    navigate(`/survey-answer${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSurveyUnitsOfMeasures({}));
    dispatch(getSurveyQuestionOptions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.answerNumeric !== undefined && typeof values.answerNumeric !== 'number') {
      values.answerNumeric = Number(values.answerNumeric);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...surveyAnswerEntity,
      ...values,
      unitOfMeasure: surveyUnitsOfMeasures.find(it => it.id.toString() === values.unitOfMeasure?.toString()),
      questionOption: surveyQuestionOptions.find(it => it.id.toString() === values.questionOption?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...surveyAnswerEntity,
          unitOfMeasure: surveyAnswerEntity?.unitOfMeasure?.id,
          questionOption: surveyAnswerEntity?.questionOption?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.surveyAnswer.home.createOrEditLabel" data-cy="SurveyAnswerCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.surveyAnswer.home.createOrEditLabel">Create or edit a SurveyAnswer</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="survey-answer-id"
                  label={translate('tinyMedicRestApp.surveyAnswer.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.answerNumeric')}
                id="survey-answer-answerNumeric"
                name="answerNumeric"
                data-cy="answerNumeric"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.answerText')}
                id="survey-answer-answerText"
                name="answerText"
                data-cy="answerText"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.answer')}
                id="survey-answer-answer"
                name="answer"
                data-cy="answer"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.comment')}
                id="survey-answer-comment"
                name="comment"
                data-cy="comment"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.active')}
                id="survey-answer-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.cursor')}
                id="survey-answer-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.lastupdated')}
                id="survey-answer-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.microSec')}
                id="survey-answer-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyAnswer.timestampentry')}
                id="survey-answer-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="survey-answer-unitOfMeasure"
                name="unitOfMeasure"
                data-cy="unitOfMeasure"
                label={translate('tinyMedicRestApp.surveyAnswer.unitOfMeasure')}
                type="select"
              >
                <option value="" key="0" />
                {surveyUnitsOfMeasures
                  ? surveyUnitsOfMeasures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="survey-answer-questionOption"
                name="questionOption"
                data-cy="questionOption"
                label={translate('tinyMedicRestApp.surveyAnswer.questionOption')}
                type="select"
                required
              >
                <option value="" key="0" />
                {surveyQuestionOptions
                  ? surveyQuestionOptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/survey-answer" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SurveyAnswerUpdate;
